import {
  successMessages,
  themeSettingsConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { themeSettingsService } from "../../services";
import { brandProfileActions } from "./brandProfile.actions";
import { success, withSpinner } from "../../../../redux/actions/utilities";

const { UPDATED_SUCCESSFULLY, REMOVED_SUCCESSFULLY } = successMessages;
const { UPDATE_THEME, EXISTING_THEME, RESET_THEME, DELETE_LOGO } =
  themeSettingsConstants;

//Function to update theme settings
const updateThemeSettings = (data, brandId) => {
  return (dispatch) => {
    withSpinner(dispatch, UPDATE_THEME, () =>
      themeSettingsService
        .updateThemeSettings(data)
        .then(
          (response) => {
            dispatch(success(response, UPDATE_THEME));
            customToast(UPDATED_SUCCESSFULLY, toastTypes.SUCCESS);
            dispatch(getThemeSettings(brandId));
            dispatch(brandProfileActions.getBrandByBrandId(brandId));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Function to fetch theme settings
const getThemeSettings = (id) => {
  return (dispatch) => {
    withSpinner(dispatch, UPDATE_THEME, () =>
      themeSettingsService
        .getThemeSettings(id)
        .then(
          (response) => dispatch(success(response, EXISTING_THEME)),
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Empty theme from redux
const resetTheme = () => (dispatch) => dispatch(success({}, RESET_THEME));

//Delete themeSetting logo
const deleteThemeSettingLogo = (brandId) => {
  return (dispatch) => {
    return withSpinner(dispatch, UPDATE_THEME, () =>
      themeSettingsService
        .deleteThemeSettingLogo(brandId)
        .then(
          (response) => {
            dispatch(success(response, DELETE_LOGO));
            customToast(REMOVED_SUCCESSFULLY, toastTypes.SUCCESS);
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
};

//Exporting functions for other files
export const themeSettingsActions = {
  updateThemeSettings,
  getThemeSettings,
  resetTheme,
  deleteThemeSettingLogo,
};
